import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UntypedFormGroup, UntypedFormBuilder, Validators} from '@angular/forms';

@Component({
    selector: 'app-new-material',
    templateUrl: './new-material.component.html',
    styleUrls: ['./new-material.component.css'],
    standalone: false
})
export class NewMaterialComponent implements OnInit {

  form: UntypedFormGroup;
  nombre: string = "";
  descripcion: string = "";
  tipo: string = "Pesaje";
  activo: boolean = true;

  constructor(private fb: UntypedFormBuilder, @Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<NewMaterialComponent>) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      nombre: [this.nombre, [Validators.required, Validators.minLength(1), Validators.maxLength(16)]],
      descripcion: [this.descripcion, [Validators.maxLength(64)]],
      tipo: [this.tipo, [Validators.required]],
      activo: [this.activo, [Validators.required]],
    });
  }

  save() {
    const {value, valid} = this.form;
    if(valid){
      this.dialogRef.close(value);
    }
  }

  close() {
    this.dialogRef.close();
  }

}
